import React, { Component } from 'react';
import { connect } from 'react-redux';

import { archiveVideoCreator, deleteVideoCreator } from 'creators/shareVideo';

import Button from 'components/ui-components/button';
import Modal from 'components/ui-components/modal';

import './styles.less';

class VideoRemoveModal extends Component {
  state = { loading: false };

  render() {
    return (
      <Modal show={true} showClose={false} onDismiss={this.props.onCloseModal}>
        <div className="video-remove-modal">
          <p>How would you like to remove this video?</p>
          <div className="button-bar">
            <Button
              disabled={this.state.loading}
              onClicked={this.handleArchiveClick}
              buttonClass="rp-secondary-4"
              value="Archive"
            />
            <Button
              disabled={this.state.loading}
              onClicked={this.handleDeleteClick}
              buttonClass="rp-primary-4"
              value="Delete"
            />
          </div>
        </div>
      </Modal>
    );
  }

  handleArchiveClick = async () => {
    this.setState({ loading: true });

    try {
      await this.props.onArchiveButtonClicked(this.props.videoId);
    } catch (e) {
      this.setState({ loading: false });
    }
  };

  handleDeleteClick = async () => {
    this.setState({ loading: true });

    try {
      await this.props.onDeleteButtonClicked(this.props.videoId);
    } catch (e) {
      this.setState({ loading: false });
    }
  };
}

const mapDispatchToProps = dispatch => {
  return {
    onArchiveButtonClicked: videoId => dispatch(archiveVideoCreator(videoId)),
    onDeleteButtonClicked: videoId => dispatch(deleteVideoCreator(videoId)),
  };
};

export default connect(null, mapDispatchToProps)(VideoRemoveModal);
